import { EOptionSymbolSide, ESymbolCategory, ISymbolTickRulesGroup } from '../../market';
import { EFillPolicyValue, EOrderState, EOrderStatus, EOrderType } from '../../order';

export enum ENotificationType {
  ALL = 'ALL',
  ORDER = 'ORDER',
  SYSTEM = 'SYSTEM',
  INFORMATION = 'INFORMATION',
  PRICE_ALERT = 'PRICE_ALERT'
}

/**
 * Component type enum for rendering notifications
 * Used to determine which notification component to display in the ALL tab
 */
export enum ENotificationComponentType {
  ORDER = 'ORDER',
  SYSTEM = 'SYSTEM',
  INFORMATION = 'INFORMATION',
  PRICE_ALERT = 'PRICE_ALERT',
  BASIC = 'BASIC'
}

export enum ENotificationSettingsType {
  NT_ORDER_CREATE = 0,
  NT_ORDER_CLOSE = 1,
  NT_ORDER_TPSL_CLOSE = 2,
  NT_ORDER_TPSL_FCM_CLOSE = 3,
  NT_MARGIN_CALL = 4,
  NT_MARGIN_STOP_OUT = 5,
  NT_ORDER_HORIZON_EXECUTION_REPORT = 17,
  NT_ORDER_HORIZON_REJECTED_ORDER = 18,
  NT_FCM_MARGIN_CALL = 6,
  NT_FCM_MARGIN_STOP_OUT = 7,
  NT_FCM_CALENDAR = 11,
  NT_FCM_SYSTEM_SECURITY = 13,
  NT_FCM_SIGNAL_EVENT = 15,
  NT_KICK_USER = 16,
  NT_FCM_SYSTEM_PUBLIC = 19,
  NT_FCM_USER_GROUP = 20,
  NT_CALENDAR_CATEGORY = 8,
  NT_CALENDAR_COUNTRY = 9,
  NT_CALENDAR_EVENT = 10,
  NT_SIGNAL_EVENT = 14,
  NT_SYSTEM_SECURITY = 12,
  NT_PRICE_ALERT_DISABLE = 21
}

export enum ENotificationTemplate {
  // ORDER TYPE
  NT_ORDER_CREATE = 'NT_ORDER_CREATE',
  NT_ORDER_CLOSE = 'NT_ORDER_CLOSE',
  NT_ORDER_TPSL_CLOSE = 'NT_ORDER_TPSL_CLOSE',
  NT_ORDER_TPSL_FCM_CLOSE = 'NT_ORDER_TPSL_FCM_CLOSE',
  NT_MARGIN_CALL = 'NT_MARGIN_CALL',
  NT_MARGIN_STOP_OUT = 'NT_MARGIN_STOP_OUT',
  NT_CTD_MRKT_ORD_SUBMITTED = 'NT_CTD_MRKT_ORD_SUBMITTED',
  NT_CTD_PNDG_ORD_SUBMITTED = 'NT_CTD_PNDG_ORD_SUBMITTED',
  NT_CTD_ORD_EXECUTED = 'NT_CTD_ORD_EXECUTED',
  NT_CTD_ORD_CLOSED = 'NT_CTD_ORD_CLOSED',
  NT_CTD_ORD_REJECTED = 'NT_CTD_ORD_REJECTED',
  NT_CTD_PNDG_ORD_DELETED = 'NT_CTD_PNDG_ORD_DELETED',
  NT_CTD_ORD_TPSL_EXECUTED = 'NT_CTD_ORD_TPSL_EXECUTED', // Centroid Edit Open Position
  NT_ORDER_HORIZON_EXECUTION_REPORT = 'NT_ORDER_HORIZON_EXECUTION_REPORT',
  NT_ORDER_HORIZON_REJECTED_ORDER = 'NT_ORDER_HORIZON_REJECTED_ORDER',
  // INFORMATION TYPE
  NT_CALENDAR_CATEGORY = 'NT_CALENDAR_CATEGORY',
  NT_CALENDAR_COUNTRY = 'NT_CALENDAR_COUNTRY',
  NT_CALENDAR_EVENT = 'NT_CALENDAR_EVENT',
  NT_SIGNAL_EVENT = 'NT_SIGNAL_EVENT',
  // SYSTEM TYPE
  NT_SYSTEM_SECURITY = 'NT_SYSTEM_SECURITY',
  NT_BACKOFFICE_NOTIFICATION = 'NT_BACKOFFICE_NOTIFICATION',
  // EMAIL TYPE
  NT_ACCOUNT_CANCEL_REQUEST = 'NT_ACCOUNT_CANCEL_REQUEST',
  NT_ROOT_ADMIN_DASHBOARD_SUMMARY = 'NT_ROOT_ADMIN_DASHBOARD_SUMMARY',
  NT_DEMO_ACCOUNT_CREATION = 'NT_DEMO_ACCOUNT_CREATION',
  NT_KICK_USER = 'NT_KICK_USER',
  NT_EXPERIENCE_DEMO_ACCOUNT_CREATION = 'NT_EXPERIENCE_DEMO_ACCOUNT_CREATION',
  NT_EXPERIENCE_RESET_PASSWORD = 'NT_EXPERIENCE_RESET_PASSWORD',
  NT_EXPERIENCE_DEMO_ACCOUNT_INTEREST = 'NT_EXPERIENCE_DEMO_ACCOUNT_INTEREST',
  // FIREBASE TYPE
  NT_FCM_CALENDAR = 'NT_FCM_CALENDAR',
  NT_FCM_SIGNAL_EVENT = 'NT_FCM_SIGNAL_EVENT',
  NT_FCM_SYSTEM_SECURITY = 'NT_FCM_SYSTEM_SECURITY',
  NT_FCM_SYSTEM_PUBLIC = 'NT_FCM_SYSTEM_PUBLIC',
  NT_FCM_USER_GROUP = 'NT_FCM_USER_GROUP',
  NT_FCM_MARGIN_CALL = 'NT_FCM_MARGIN_CALL',
  NT_FCM_MARGIN_STOP_OUT = 'NT_FCM_MARGIN_STOP_OUT',
  // PRICE ALERT FCM TYPE
  NT_FCM_PRICE_ALERT_TRIGGERED_ABOVE = 'NT_FCM_PRICE_ALERT_TRIGGERED_ABOVE',
  NT_FCM_PRICE_ALERT_TRIGGERED_BELOW = 'NT_FCM_PRICE_ALERT_TRIGGERED_BELOW',
  NT_FCM_PRICE_ALERT_TRIGGERED_CROSS_ABOVE = 'NT_FCM_PRICE_ALERT_TRIGGERED_CROSS_ABOVE',
  NT_FCM_PRICE_ALERT_TRIGGERED_CROSS_BELOW = 'NT_FCM_PRICE_ALERT_TRIGGERED_CROSS_BELOW',
  NT_FCM_PRICE_ALERT_TRIGGERED_PERCENTAGE_REACH = 'NT_FCM_PRICE_ALERT_TRIGGERED_PERCENTAGE_REACH',
  // PRICE ALERT TYPE
  NT_PRICE_ALERT_TRIGGERED_ABOVE = 'NT_PRICE_ALERT_TRIGGERED_ABOVE',
  NT_PRICE_ALERT_TRIGGERED_BELOW = 'NT_PRICE_ALERT_TRIGGERED_BELOW',
  NT_PRICE_ALERT_TRIGGERED_CROSS_ABOVE = 'NT_PRICE_ALERT_TRIGGERED_CROSS_ABOVE',
  NT_PRICE_ALERT_TRIGGERED_CROSS_BELOW = 'NT_PRICE_ALERT_TRIGGERED_CROSS_BELOW',
  NT_PRICE_ALERT_TRIGGERED_PERCENTAGE_REACH = 'NT_PRICE_ALERT_TRIGGERED_PERCENTAGE_REACH'
}

export enum EHorizonExecuteType {
  NEW = 'NEW', // '0'
  PARTIAL_FILL = 'PARTIAL_FILL', // '1'
  FILL = 'FILL', // '2'
  DONE_FOR_DAY = 'DONE_FOR_DAY', // '3'
  CANCELED = 'CANCELED', // '4'
  REPLACED = 'REPLACED', // '5'
  PENDING_CANCEL = 'PENDING_CANCEL', // '6'
  STOPPED = 'STOPPED', // '7'
  REJECTED = 'REJECTED', // '8'
  SUSPENDED = 'SUSPENDED', // '9'
  PENDING_NEW = 'PENDING_NEW', // 'A'
  CALCULATED = 'CALCULATED', // 'B'
  EXPIRED = 'EXPIRED', // 'C'
  RESTATED = 'RESTATED', // 'D'
  PENDING_REPLACE = 'PENDING_REPLACE', // 'E'
  TRADE = 'TRADE', // 'F'
  TRADE_CORRECT = 'TRADE_CORRECT', // 'G'
  TRADE_CANCEL = 'TRADE_CANCEL', // 'H'
  ORDER_STATUS = 'ORDER_STATUS', // 'I'
  TRADE_IN_A_CLEARING_HOLD = 'TRADE_IN_A_CLEARING_HOLD', // 'J'
  TRADE_HAS_BEEN_RELEASED_TO_CLEARING = 'TRADE_HAS_BEEN_RELEASED_TO_CLEARING', // 'K'
  TRIGGERED_OR_ACTIVATED_BY_SYSTEM = 'TRIGGERED_OR_ACTIVATED_BY_SYSTEM' // 'L'
}

export enum ENotificationOrderStateCentroid {
  PENDING = 'PENDING',
  PARTIAL = 'PARTIAL',
  FILLED = 'FILLED',
  CLOSED = 'CLOSED',
  MODIFIED = 'MODIFIED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED'
}

export interface IGetNotificationParams {
  notificationType: ENotificationType;
}

export interface IDeleteNotificationParams extends IGetNotificationParams {
  notificationId: string;
}

export interface IUpdateNotificationParams extends IGetNotificationParams {
  settingType: ENotificationSettingsType;
  isDisable: boolean;
}

export interface INotificationSettings {
  notificationType: ENotificationType;
  settingType: ENotificationSettingsType;
  isDisable: boolean;
  marginLevel: number | null;
}

export interface INotificationSummary {
  unread: number;
  notificationType: ENotificationType;
}

export interface INotification {
  id: string;
  message: string;
  url: string;
  title: string;
  created: number;
  updated: number;
  publishDate: number;
  orderId: string;
  settingType: ENotificationSettingsType;
  metadata: INotificationMetadata | null;
  read: boolean;
  description: string;
  notificationTemplate: ENotificationTemplate;
  sequenceNo: number | null;
}

/** ToDo */
export interface INotificationMetadata {
  symbol?: string;
  eventId?: string;
  eventDate?: number;
  hasExpired?: boolean;

  avgFilledPrice: number;
  closePrice: number;
  cmd: EOrderType; // cmd - OrderType
  comment: string;
  expireTime: number;
  lotSize: number;
  filledLotSize: number;
  remainedLotSize: number;
  metatraderId: number;
  openPrice: number;
  openTime: number;
  orderId: string;
  orderState: EOrderState;
  price: number; // Limit Price
  profit: number;
  stopLoss: number;
  stopPrice: number;
  takeProfit: number;
  volume: number;
  symbolType: ESymbolCategory;
  digit?: number;

  // Centroid
  centroidNotificationOrderState: ENotificationOrderStateCentroid;
  centroidTimeInForce: EFillPolicyValue;
  centroidSymbolDecimal: number;
  centroidNotional: number;
  swap: number;
  margin: number;
  commission: number;
  description?: string;

  // Horizon Only
  tradeId: number; // tradeId - NOT IN USE
  symbolSide: EOptionSymbolSide;
  type: number;
  horizonExecuteType: EHorizonExecuteType;
  horizonOrderStatus: EOrderStatus;
  horizonTimeInForce: EFillPolicyValue;
  tickRulesGroup: ISymbolTickRulesGroup[];
  origClOrdId: string; // Original order ID. When an order is edited, a new order ID replaces the old one, and this field stores the previous order ID.
}

export interface IRawPushNotificationData {
  eventId?: string;
  orderId?: string | null;
  metatraderId?: string;
  serverId?: string;
  settingType: ENotificationTemplate; // BE return as string instead of integer (ENotificationSetting)
  symbol?: string;
  eventDate?: string;
  deviceIos?: string;
  deviceAndroid?: string;
  deviceIosToKick?: string;
  deviceAndroidToKick?: string;
  activeIosDevice?: string;
  activeAndroidDevice?: string;
}

/** FCM notification data type */
export interface IFCMPushNotificationData
  extends Omit<IRawPushNotificationData, 'metatraderId' | 'serverId' | 'eventDate'> {
  metatraderId?: number;
  serverId?: number;
  eventDate?: number;
}
